import { Component, OnInit, OnDestroy } from "@angular/core";
import { SettingService } from "../../_services/setting.service";
import { ProductService } from "../../_services/product.service";
import { UserService } from "../../_services/user.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, NavigationEnd } from "@angular/router";
import { FlashMessagesService } from "angular2-flash-messages";
import { CommonService } from "../../_services/common.service";


@Component({
  selector: "app-listing",
  templateUrl: "./listing.component.html",
  styleUrls: ["./listing.component.css"]
})
export class ListingComponent implements OnInit, OnDestroy {
  public productLists: Array<any> = [];
  public bestSellingProducts: Array<any> = [];
  public lessOrderLimitProducts: Array<any> = [];
  public hideProducts: Array<any> = [];
  public loading = false;
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public limit = 10;
  public search: string = "";
  public sortColumnName = "name";
  public sortDirection = "asc";
  public filterProductText: string;
  public filterBrandText: string = "";
  public filterStyleText: string = "";
  public brand_list: Array<any> = [];
  public style_list: Array<any> = [];
  public showForm = false;
  public viewProductData: any = {};
  public productOptions: any = {};
  navigationSubscription;

  constructor(
    private ProductService: ProductService,
    private SettingService: SettingService,
    private UserService: UserService,
    private commonService: CommonService,
    private router: Router,
    private _flashMessagesService: FlashMessagesService
  ) {
    // override the route reuse strategy
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.navigationSubscription = this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() {
    this.getProductOptions();
    this.getProducts();
    this.getBrandList();
    this.getStyleList();
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
  OnSubmit() { }

  productThumb(img) {
    var re = new RegExp("_fm", "g");
    img = img.replace(re, "_fs");
    return img;
  }

  isEnabled(check_val) {
    return check_val ? true : false;
  }

  updateProduct(id, upd_type, upd_val) {
    if (upd_type == "best_selling_products") {
      let bestSellingProducts = this.bestSellingProducts.find(x => x === id);
      if (!bestSellingProducts) {
        this.bestSellingProducts.push(id);

        let options = {
          best_selling_products: this.bestSellingProducts
        };
        this.setProductOption(options);
      }
      else {
        this.bestSellingProducts = this.bestSellingProducts.filter(
          item => item !== id
        );
        let options = {
          best_selling_products: this.bestSellingProducts
        };
        this.setProductOption(options);
      }
    }
    if (upd_type == "hide_products") {
      let hideProducts = this.hideProducts.find(x => x === id);
      if (!hideProducts) {
        this.hideProducts.push(id);

        let options = {
          hide_products: this.hideProducts
        };
        this.setProductOption(options);
      }
      else {
        this.hideProducts = this.hideProducts.filter(
          item => item !== id
        );
        let options = {
          hide_products: this.hideProducts
        };
        this.setProductOption(options);
      }
    }

    if (upd_type == "less_order_limit_products") {
      let lessOrderLimitProducts = this.lessOrderLimitProducts.find(
        x => x === id
      );
      if (!lessOrderLimitProducts) {
        this.lessOrderLimitProducts.push(id);
        let options = {
          less_order_limit_products: this.lessOrderLimitProducts
        };
        this.setProductOption(options);
      }
      else {
        this.lessOrderLimitProducts = this.lessOrderLimitProducts.filter(
          item => item !== id
        );
        let options = {
          less_order_limit_products: this.lessOrderLimitProducts
        };
        this.setProductOption(options);
      }
    }
  }

  setProductOption(options) {
    this.SettingService.setSetting(options).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show("Details updated successfuly!", {
            cssClass: "alert-success",
            timeout: 5000
          });
        }
      },
      err => {
        console.log("Error =", err);
        this._flashMessagesService.show(err, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  }

  getProducts = function () {
    this.loading = true;
    this.productOptions = { limit: this.limit, page: this.page, provider: "ssactivewear" };
    if (this.filterProductText) {
      this.productOptions.search = this.filterProductText;
    }
    if (this.filterBrandText) {
      this.productOptions.brand_id = this.filterBrandText;
    }
    if (this.filterStyleText) {
      this.productOptions.style_id = [this.filterStyleText];
    }
    if (this.sortDirection) {
      // this.productOptions.orderBy = this.sortColumnName;
      this.productOptions.direction = this.sortDirection;
    }
    this.productOptions.is_admin = true;

    this.ProductService.getProducts(this.productOptions).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.productLists =
            response.data.records.length > 0 ? response.data.records : [];

          this.total = response.data.total;
          this.current_page = response.data.current_page;

          this.limit = response.data.limit;
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  };

  getProductOptions = function () {
    let options = ["best_selling_products", "less_order_limit_products", "hide_products"];
    this.SettingService.getSetting(options).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            let best_selling_products = response.data.best_selling_products
              ? JSON.parse(response.data.best_selling_products)
              : [];
            let less_order_limit_products = response.data
              .less_order_limit_products
              ? JSON.parse(response.data.less_order_limit_products)
              : [];
            let hide_products = response.data
              .hide_products
              ? JSON.parse(response.data.hide_products)
              : [];
            this.bestSellingProducts = best_selling_products;
            this.lessOrderLimitProducts = less_order_limit_products;
            this.hideProducts = hide_products;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  };

  getBrandList = function () {
    let data = {
      id: localStorage.getItem("userID"),
      provider: "ssactivewear",
      limit: 500
    };
    this.commonService.apiService(
      "POST",
      "brands",
      data
    ).subscribe(
      (response: any) => {
        // let totalRecords = response.data.records.length;
        if (response.status === true) {
          this.brand_list = response.data.records;
          // if (totalRecords > 0) {
          //   for (var i in response.data.records) {
          //     this.brand_list.push(response.data.records[i]);
          //   }
          // }
        }
      },
      err => { }
    );
  };

  getStyleList = function () {
    let data = {
      id: localStorage.getItem("userID"),
      provider: "ssactivewear",
      limit: 1000
    };
    this.commonService.apiService(
      "POST",
      "styles",
      data
    ).subscribe(
      (response: any) => {
        let totalRecords = response.data.records.length;
        if (response.status === true) {
          if (totalRecords > 0) {
            for (var i in response.data.records) {
              this.style_list.push(response.data.records[i]);
            }
          }
        }
      },
      err => { }
    );
  };

  filterProduct(): void {
    this.page = 1;
    this.total = 0;
    this.getProducts();
  }

  clearFilterProduct(): void {
    this.filterProductText = "";
    this.page = 1;
    this.total = 0;
    this.getProducts();
  }

  goToPage(n: number): void {
    this.page = n;
    this.getProducts();
  }

  onNext(): void {
    this.page++;
    this.getProducts();
  }

  onPrev(): void {
    this.page--;
    this.getProducts();
  }

  goSort($event) {
    this.sortColumnName = $event.columnName;
    this.sortDirection = $event.sortDirection;
    this.getProducts();
  }

  toggleForm(loading) {
    if (loading == true) {
      this.viewProductData = {};
      this.ngOnInit();
    }
    this.showForm = !loading;
    return !this.showForm;
  }

  viewProduct(productObj) {
    this.loading = true;
    this.viewProductDetail(productObj);
    this.showForm = true;
  }

  viewProductDetail(productObj) {
    this.productOptions = {};
    if (productObj) {
      this.productOptions.product_id = productObj.product_id;
    }
    this.productOptions.is_admin = true;
    this.productOptions.no_ordered_value = true;
    this.ProductService.getProductById(this.productOptions).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.viewProductData = response.data;
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/listing/listing.component.ts